import { useContext, useEffect, useState } from "react";
//@ts-ignore
import logoSrc from "../../img/logo.png";
//@ts-ignore
import us from "../../img/us.png";
//@ts-ignore
import am from "../../img/am.png";
//@ts-ignore
import ru from "../../img/ru.png";
import { MainContext } from "../../MainContext";
import DropdownMenu from "./DropdownMenu";

const languages = [
    { code: "Am", label: "Armenian", flag: am },
	{ code: "En", label: "English", flag: us },
	{ code: "Ru", label: "Russian", flag: ru },
];

export const Navbar = () => {
	const [selected, setSelected] = useState(languages[0]);
	const [open, setOpen] = useState(false);
	const { setLang, updateAll, openModal } = useContext(MainContext);

	const toggleDropdown = () => setOpen(!open);

	const selectLanguage = (lang: typeof selected) => {
		setSelected(lang);
		setOpen(false);
		setLang(lang.code);
	};

	useEffect(() => {
		updateAll();
	}, [selected]);

	const {
		texts: { navbar: texts },
		staticTexts: { contactUsButton: contactUsButton },
	} = useContext(MainContext);

	return (
		<div className="navbar">
			<img src={window.innerWidth < 760 ? "/mini-logo.png" : logoSrc} alt="" />
			<div className="buttons">
				<div className="btn-blue" onClick={() => openModal({ type: "contact" })}>
					{contactUsButton.text}
				</div>
				<div className="languageSelector">
					<div className="flagWrapper" onClick={toggleDropdown}>
						<img src={selected.flag} alt={selected.label} className="flag" />
					</div>
					{open ? (
						<div onMouseLeave={toggleDropdown} className="dropdown">
							{languages
								.filter((lang) => lang.code !== selected.code)
								.map((lang) => (
									<div
										key={lang.code}
										className="dropdownItem"
										onClick={() => selectLanguage(lang)}
									>
										<img src={lang.flag} alt={lang.label} className="flag" />
									</div>
								))}
						</div>
					) : (
						""
					)}
				</div>
				<DropdownMenu />
			</div>
		</div>
	);
};
